



















import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import { NBMessageWarning } from '@/utils/nBMessage'
interface TitleHead {
  title?: string;
  icon?: string;
}
@Component
export default class CardItemHead extends Vue {
  /**
   * val        添加分组名称
   * id         用于点击创建、编辑时做数据回传
   * name       显示内容
   * titleLeft  左侧显示内容
   * titleRight 右侧显示内容
   * type       类型 edit  add
   */

  /**
   *  edit 编辑状态
   *   add 添加状态
   */

  /**
   * 注意
   * type为 add时候
   * titleLeft 为显示内容
   */

  /**
   * 方法
   * onAdd type为 add时， 添加
   *
   * onEdit 编辑 type edit时
   *
   * onDel  删除 type edit 时
   *
   * handleHover 鼠标移入显示编辑删除
   */

  @Prop({ default: 'add' }) type!: string;
  @Prop() id!: (string | number);
  @Prop() name!: (string | number);
  @Prop() cardArr!: any
  hidden: boolean = false
  val: string = ''
  // 添加组件
  add(val:string) {
    if (val === '') {
      NBMessageWarning(this, { message: '分组名称不能为空' })
      return
    }
    this.$emit('on-add', val)
    this.val = ''
  }
  handleHover(type:string) {
    type === 'in' ? this.hidden = false : this.hidden = true
  }

  // 删除
  @Emit()
  onDel(id: string | number) {
    return id
  }
}
